import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout.js";
import { useLocation } from "react-router-dom";
import { apiFetch } from "../../api.js";
import Select from "react-select";

const HypothecationmasterDetailsDesign = () => {
  const allowAlphabets = (v) => v.replace(/[^a-zA-Z ]/g, "");
  const allowNumbers = (v) => v.replace(/[^0-9]/g, "");
  const validateEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  const [emailError, setEmailError] = useState("");
  const navigate = useNavigate();
  const [BankName, setBankName] = useState("");
  const [Address, setAddress] = useState("");
  const [Country, setCountry] = useState("");
  const [State, setState] = useState("");
  const [City, setCity] = useState("");
  const [CompanyAuthorised, setCompanyAuthorised] = useState("Yes");
  const [BranchName, setBranchName] = useState("");
  const [Branchaddress, setBranchaddress] = useState("");
  const [Branchcode, setBranchcode] = useState("");
  const [Ifsccode, setIfsccode] = useState("");
  const [Contactpersonone, setContactpersonone] = useState("");
  const [Contactpersontwo, setContactpersontwo] = useState("");
  const [Contactpersonthree, setContactpersonthree] = useState("");
  const [Designationone, setDesignationone] = useState("");
  const [Designationtwo, setDesignationtwo] = useState("");
  const [Designationthree, setDesignationthree] = useState("");
  const [Mobilenoone, setMobilenoone] = useState("");
  const [Mobilenotwo, setMobilenotwo] = useState("");
  const [Mobilenothree, setMobilenothree] = useState("");
  const [Emailone, setEmailone] = useState("");
  const [Emailtwo, setEmailtwo] = useState("");
  const [Emailthree, setEmailthree] = useState("");
  const [Executivepayouttype, setExecutivepayouttype] = useState("");
  const [Executivepayoutslab, setExecutivepayoutslab] = useState("");
  const [Dealerpayoutslab, setDealerpayoutslab] = useState("");
  const [gridRows, setGridRows] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [ipAddress, setIpAddress] = useState("");
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
  const [editingChildId, setEditingChildId] = useState(null);
  const [parentId, setParentId] = useState(null);
  const location = useLocation();
  const parentUnq = location.state?.hp_2 || null;

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "14px",
    flexWrap: "nowrap", // 🔥 no wrapping (forces one row)
    width: "100%",
    marginTop: "30px",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px",
    height: "44px",
    padding: "0 18px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
  });
  const inputStyle = {
    padding: "10px",
    marginTop: "5px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    width: "100%",
    boxSizing: "border-box",
  };
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: "40px",
      height: "40px",
      borderRadius: "5px",
      borderColor: "#ccc",
      boxShadow: "none",
    }),
    valueContainer: (base) => ({
      ...base,
      height: "40px",
      padding: "0 10px",
      display: "flex",
      alignItems: "center",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "40px",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
  };

  const countryOptions = [{ value: "INDIA", label: "INDIA" }];
  const payoutTypeOptions = [
    { value: "AMOUNT", label: "AMOUNT" },
    { value: "PERCENTAGE", label: "PERCENTAGE" },
  ];

  useEffect(() => {
    apiFetch("/api/get-ip")
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);

  const handleSave = async () => {
    try {
      if (!BankName) {
        alert("Bank Name is required");
        return;
      }
      if (!BranchName || !Branchcode) {
        alert("Branch Name and Branch Code are required");
        return;
      }
      let pid = parentId;
      if (!pid) {
        const parentResponse = await apiFetch(
          "/api/hypothecation/save-parent",
          {
            method: "POST",
            body: JSON.stringify({
              BankName,
              Address,
              City,
              State,
              Country,
              CompanyAuthorised,
              Contactpersonone,
              Designationone,
              Mobilenoone,
              Contactpersontwo,
              Designationtwo,
              Mobilenotwo,
              Contactpersonthree,
              Designationthree,
              Mobilenothree,
              Emailone,
              userid: storedUserInfo?.userId || "",
              ipAddress,
            }),
          },
        );
        const parentRes = await parentResponse.json();
        if (!parentRes || parentRes.err === "0") {
          alert(parentRes?.msg || "Parent save failed");
          return;
        }
        pid = parentRes.err;
        setParentId(pid);
      }
      const childResponse = await apiFetch(
        "/api/hypothecation/save-child",
        {
          method: "POST",
          body: JSON.stringify({
            parentId: pid,
            BranchName,
            Branchaddress,
            Branchcode,
            Ifsccode,
            Contactpersonone,
            Contactpersontwo,
            Contactpersonthree,
            Designationone,
            Designationtwo,
            Designationthree,
            Mobilenoone,
            Mobilenotwo,
            Mobilenothree,
            Emailone,
            Emailtwo,
            Emailthree,
            Executivepayouttype,
            Executivepayoutslab,
            Dealerpayoutslab,
          }),
        },
      );
      const childRes = await childResponse.json();
      if (childRes.err === "0") {
        alert(childRes.msg);
        return;
      }
      await loadGrid(pid);
      clearChildFields();
      alert("Saved Successfully");
    } catch (err) {
      console.error("Save error:", err);
      alert("Error while saving data");
    }
  };

  const clearChildFields = () => {
    setBranchName("");
    setBranchaddress("");
    setBranchcode("");
    setIfsccode("");
    setContactpersonone("");
    setContactpersontwo("");
    setContactpersonthree("");
    setDesignationone("");
    setDesignationtwo("");
    setDesignationthree("");
    setMobilenoone("");
    setMobilenotwo("");
    setMobilenothree("");
    setEmailone("");
    setEmailtwo("");
    setEmailthree("");
    setExecutivepayouttype("");
    setExecutivepayoutslab("");
    setDealerpayoutslab("");
  };

  const loadGrid = async (parentId) => {
    try {
      const response = await apiFetch(
        "/api/hypothecation/grid",
        {
          method: "POST",
          body: JSON.stringify({ what: "griddata11", hp_2: parentId }),
        },
      );
      const data = await response.json();
      console.log("GRID DATA:", data);
      setGridRows(data || []);
    } catch (err) {
      console.error("Grid load error", err);
    }
  };

  const handleEdit = async (row) => {
    try {
      setIsEditing(true);
      setEditingChildId(row.hp_c_2);
      const response = await apiFetch(
        "/api/hypothecation/edit",
        { method: "POST", body: JSON.stringify({ childId: row.hp_c_2 }) },
      );
      const d = await response.json();
      setBranchName(d.bname || "");
      setBranchaddress(d.add1 || "");
      setBranchcode(d.bcode || "");
      setIfsccode(d.ifsccode || "");
      setContactpersonone(d.c1 || "");
      setContactpersontwo(d.c2 || "");
      setContactpersonthree(d.c3 || "");
      setDesignationone(d.d1 || "");
      setDesignationtwo(d.d2 || "");
      setDesignationthree(d.d3 || "");
      setMobilenoone(d.m1 || "");
      setMobilenotwo(d.m2 || "");
      setMobilenothree(d.m3 || "");
      setEmailone(d.e1 || "");
      setEmailtwo(d.e2 || "");
      setEmailthree(d.e3 || "");
      setExecutivepayouttype(d.type ? d.type.toUpperCase() : "");

      setExecutivepayoutslab(d.eslab || "");
      setDealerpayoutslab(d.dslab || "");
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (err) {
      console.error("Edit load error", err);
      alert("Failed to load data");
    }
  };

  const handleExit = () => {
    navigate("/HypothecationGrid");
  };

  useEffect(() => {
    if (parentUnq) {
      loadParentForEdit(parentUnq);
      setParentId(parentUnq);
    }
  }, [parentUnq]);

  const loadParentForEdit = async (parentId) => {
    try {
      const response = await apiFetch(
        "/api/hypothecation/edit-parent",
        { method: "POST", body: JSON.stringify({ parentId }) },
      );
      const d = await response.json();
      if (!d || !d.unqid) return;
      setBankName(d.name || "");
      setAddress(d.add1 || "");
      setCity(d.city || "");
      setState(d.state || "");
      setCountry(d.country || "");
      setCompanyAuthorised(d.authorised || "Yes");
      setContactpersonone(d.cp || "");
      setDesignationone(d.desi || "");
      setMobilenoone(d.mob || "");
      setContactpersontwo(d.cp2 || "");
      setDesignationtwo(d.des2 || "");
      setMobilenotwo(d.mob2 || "");
      setContactpersonthree(d.cp3 || "");
      setDesignationthree(d.des3 || "");
      setMobilenothree(d.mob3 || "");

      await loadGrid(parentId);
    } catch (err) {
      console.error("Parent edit load error", err);
    }
  };

  const handleUpdate = async () => {
    try {
      if (!parentId) {
        alert("Parent ID missing");
        return;
      }
      if (!editingChildId) {
        alert("Please select a branch to update");
        return;
      }
      await apiFetch(
        "/api/hypothecation/update-parent",
        {
          method: "POST",
          body: JSON.stringify({
            parentId,
            BankName,
            Address,
            City,
            State,
            Country,
            CompanyAuthorised,
            Contactpersonone,
            Designationone,
            Mobilenoone,
            Contactpersontwo,
            Designationtwo,
            Mobilenotwo,
            Contactpersonthree,
            Designationthree,
            Mobilenothree,
            Emailone,
            userid: storedUserInfo?.userId || "",
          }),
        },
      );
      await apiFetch(
        "/api/hypothecation/update-child",
        {
          method: "POST",
          body: JSON.stringify({
            parentId,
            childId: editingChildId,
            BranchName,
            Branchaddress,
            Branchcode,
            Ifsccode,
            Contactpersonone,
            Contactpersontwo,
            Contactpersonthree,
            Designationone,
            Designationtwo,
            Designationthree,
            Mobilenoone,
            Mobilenotwo,
            Mobilenothree,
            Emailone,
            Emailtwo,
            Emailthree,
            Executivepayouttype,
            Executivepayoutslab,
            Dealerpayoutslab,
          }),
        },
      );
      setEditingChildId(null);
      clearChildFields();
      await loadGrid(parentId);

      alert("Updated Successfully");
    } catch (err) {
      console.error("Update error:", err);
      alert("Update failed");
    }
  };

  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div className="header">Hypothecation Master</div>

          {/* ---------------- FORM ROW 1 ---------------- */}
          <div className="form-row">
            <div className="form-column">
              <label>Bank Name</label>
              <input
                type="text"
                value={BankName}
                onChange={(e) => setBankName(e.target.value)}
              />
            </div>
            <div className="form-column">
              <label>Address</label>
              <input
                type="text"
                value={Address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </div>
          </div>
          {/* ---------------- FORM ROW 2 ---------------- */}
          <div className="form-row">
            <div className="form-column">
              <label>Country</label>
              <Select
                classNamePrefix="rs"
                options={countryOptions}
                value={countryOptions.find((o) => o.value === Country) || null}
                onChange={(selected) => setCountry(selected?.value)}
                styles={customStyles}
                placeholder="Select Country"
                isSearchable
              />
            </div>
            <div className="form-column">
              <label>State</label>
              <input
                type="text"
                value={State}
                onChange={(e) => setState(e.target.value)}
              />
            </div>
            <div className="form-column">
              <label>City</label>
              <input
                type="text"
                value={City}
                onChange={(e) => setCity(e.target.value)}
              />
            </div>
            <div className="form-column company-auth">
              <label>Company Authorised</label>

              <div className="radio-group">
                <label>
                  <input
                    type="radio"
                    name="companyAuth"
                    value="Yes"
                    checked={CompanyAuthorised === "Yes"}
                    onChange={(e) => setCompanyAuthorised(e.target.value)}
                  />
                  Yes
                </label>

                <label>
                  <input
                    type="radio"
                    name="companyAuth"
                    value="No"
                    checked={CompanyAuthorised === "No"}
                    onChange={(e) => setCompanyAuthorised(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>
          </div>
          <br></br>
          <div className="header1">Branch Details</div>
          {/* ---------------- FORM ROW 1 ---------------- */}
          <div className="form-row">
            <div className="form-column">
              <label>Branch Name</label>
              <input
                type="text"
                value={BranchName}
                onChange={(e) => setBranchName(e.target.value)}
              />
            </div>
          </div>
          {/* ---------------- FORM ROW 2 ---------------- */}
          <div className="form-row">
            <div className="form-column">
              <label>Branch Address</label>
              <input
                type="text"
                value={Branchaddress}
                onChange={(e) => setBranchaddress(e.target.value)}
              />
            </div>
            <div className="form-column">
              <label>Branch Code</label>
              <input
                type="number"
                value={Branchcode}
                onChange={(e) => setBranchcode(e.target.value)}
              />
            </div>
            <div className="form-column">
              <label>IFSC Code</label>
              <input
                type="text"
                value={Ifsccode}
                onChange={(e) => setIfsccode(e.target.value)}
              />
            </div>
          </div>
          {/* ---------------- FORM ROW 3 ---------------- */}
          <div className="form-row">
            <div className="form-column">
              <label>Contact Person 1</label>
              <input
                type="text"
                value={Contactpersonone}
                onChange={(e) => setContactpersonone(e.target.value)}
              />
            </div>
            <div className="form-column">
              <label>Contact Person 2</label>
              <input
                type="text"
                value={Contactpersontwo}
                onChange={(e) => setContactpersontwo(e.target.value)}
              />
            </div>
            <div className="form-column">
              <label>Contact Person 3</label>
              <input
                type="text"
                value={Contactpersonthree}
                onChange={(e) => setContactpersonthree(e.target.value)}
              />
            </div>
          </div>
          {/* ---------------- FORM ROW 4 ---------------- */}
          <div className="form-row">
            <div className="form-column">
              <label>Designation 1</label>
              <input
                type="text"
                value={Designationone}
                onChange={(e) => setDesignationone(e.target.value)}
              />
            </div>
            <div className="form-column">
              <label>Designation 2</label>
              <input
                type="text"
                value={Designationtwo}
                onChange={(e) => setDesignationtwo(e.target.value)}
              />
            </div>
            <div className="form-column">
              <label>Designation 3</label>
              <input
                type="text"
                value={Designationthree}
                onChange={(e) => setDesignationthree(e.target.value)}
              />
            </div>
          </div>
          {/* ---------------- FORM ROW 5 ---------------- */}
          <div className="form-row">
            <div className="form-column">
              <label>Mobile No 1</label>
              <input
                type="text"
                value={Mobilenoone}
                onChange={(e) => setMobilenoone(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-column">
              <label>Mobile No 2</label>
              <input
                type="text"
                value={Mobilenotwo}
                onChange={(e) => setMobilenotwo(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-column">
              <label>Mobile No 3</label>
              <input
                type="text"
                value={Mobilenothree}
                onChange={(e) => setMobilenothree(allowNumbers(e.target.value))}
              />
            </div>
          </div>
          {/* ---------------- FORM ROW 6 ---------------- */}
          <div className="form-row">
            <div className="form-column">
              <label>Email 1</label>
              <input
                type="text"
                value={Emailone}
                onChange={(e) => {
                  const val = e.target.value;
                  setEmailone(val);

                  if (val.trim() === "") {
                    setEmailError("Email is required");
                  } else if (!validateEmail(val)) {
                    setEmailError("Invalid email format");
                  } else {
                    setEmailError("");
                  }
                }}
              />

              {emailError && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {emailError}
                </span>
              )}
            </div>
            <div className="form-column">
              <label>Email 2</label>
              <input
                type="text"
                value={Emailtwo}
                onChange={(e) => {
                  const val = e.target.value;
                  setEmailtwo(val);

                  if (val.trim() === "") {
                    setEmailError("Email is required");
                  } else if (!validateEmail(val)) {
                    setEmailError("Invalid email format");
                  } else {
                    setEmailError("");
                  }
                }}
              />

              {emailError && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {emailError}
                </span>
              )}
            </div>
            <div className="form-column">
              <label>Email 3</label>
              <input
                type="text"
                value={Emailthree}
                onChange={(e) => {
                  const val = e.target.value;
                  setEmailthree(val);

                  if (val.trim() === "") {
                    setEmailError("Email is required");
                  } else if (!validateEmail(val)) {
                    setEmailError("Invalid email format");
                  } else {
                    setEmailError("");
                  }
                }}
              />

              {emailError && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {emailError}
                </span>
              )}
            </div>
          </div>
          {/* ---------------- FORM ROW 6 ---------------- */}
          <div className="form-row">
            <div className="form-column">
              <label>Executive Payout type</label>
              <Select
                classNamePrefix="rs"
                options={payoutTypeOptions}
                value={
                  payoutTypeOptions.find(
                    (o) => o.value === Executivepayouttype,
                  ) || null
                }
                onChange={(selected) => setExecutivepayouttype(selected?.value)}
                styles={customStyles}
                placeholder="Select Payout Type"
                isSearchable
                /* 🔥 THIS FIXES THE ISSUE */
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
            <div className="form-column">
              <label>Executive Payout Slab</label>
              <input
                type="text"
                value={Executivepayoutslab}
                onChange={(e) =>
                  setExecutivepayoutslab(allowNumbers(e.target.value))
                }
              />
            </div>
            <div className="form-column">
              <label>Dealer Payout Slab</label>
              <input
                type="text"
                value={Dealerpayoutslab}
                onChange={(e) =>
                  setDealerpayoutslab(allowNumbers(e.target.value))
                }
              />
            </div>
          </div>
          {/* Grid Section */}
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th style={{ width: "10%" }}>S.N.</th>
                  <th style={{ width: "50%" }}> Branch Name</th>
                  <th style={{ width: "30%" }}>Branch Code</th>
                  <th style={{ width: "10%" }}>Action</th>
                </tr>
              </thead>

              <tbody>
                {gridRows.map((row, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>

                    <td>
                      <input
                        type="text"
                        className="grid-input"
                        value={row.branchname || ""}
                        readOnly
                      />
                    </td>

                    <td>
                      <input
                        type="text"
                        className="grid-input"
                        value={row.code || ""}
                        readOnly
                      />
                    </td>
                    <td>
                      <button
                        className="btn-edit"
                        onClick={() => handleEdit(row)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <br></br>

          {/* ---------------- BUTTONS ---------------- */}
          <div style={buttonContainerStyle}>
            {parentUnq === null && (
              <button style={buttonStyle("#4caf50")} onClick={handleSave}>
                Save
              </button>
            )}
            {parentUnq !== null && (
              <button
                style={buttonStyle("#2e20abff")}
                type="button"
                onClick={handleUpdate}
              >
                Update
              </button>
            )}
            <button style={buttonStyle("#ab2025")} onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>

      {/* ----------------------------------------------------
            CSS EXACTLY LIKE INSURANCE MASTER / RATE MASTER
      ---------------------------------------------------- */}
      <style>
        {`
/* ================= PAGE ================= */

.page-container {
  width: 100%;
  min-height: 100vh;
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  padding: 10px;
  box-sizing: border-box;
}

.container {
  width: 100%;
  max-width: 1400px;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 8px rgba(0,0,0,.1);
}

/* ================= HEADERS ================= */

.header,
.header1 {
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  padding: 15px;
  background: #8B1E3F;
  color: #fff;
  border-radius: 6px;
  margin-bottom: 20px;
}

/* ================= FORM GRID ================= */

.form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}



.form-column {
  display: flex;
  flex-direction: column;
}

label {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
}

/* ================= INPUTS ================= */

input,
select {
  height: 40px !important;
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
  box-sizing: border-box;
  background: #fff;
}

input[type="date"] {
  padding-right: 35px;
}

/* ================= react-select FIX ================= */

.rs__control {
  min-height: 40px !important;
  height: 40px !important;
  border-radius: 5px !important;
}

.rs__value-container {
  height: 40px !important;
  padding: 0 10px !important;
  display: flex;
  align-items: center;
}

.rs__indicator {
  padding: 6px !important;
}

.rs__menu-portal {
  z-index: 9999 !important;
}

/* ================= RADIO ================= */

.company-auth {
  max-width: 220px;
}

.radio-group {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 8px;
}

.radio-group label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
}

.radio-group input {
  width: 16px;
  height: 16px;
}

/* ================= TABLE ================= */

.table-container {
  width: 100%;
  overflow-x: auto;
  margin-top: 20px;
  border: 1px solid #ddd;
  border-radius: 6px;
}

table {
  width: 100%;
  min-width: 800px;
  border-collapse: collapse;
  font-size: 13px;
}

th,
td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: center;
}

thead tr {
  background: #f8bcbc;
}

.grid-input {
  width: 100%;
  height: 32px;
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: center;
}

/* ================= BUTTONS ================= */

.button-container {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 20px;
  flex-wrap: wrap;
}

.button-container button {
  min-width: 120px;
  padding: 12px 18px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
}

.btn-save {
  background: #4caf50;
  color: #fff;
  border: none;
}

.btn-exit {
  background: #a20d0d;
  color: #fff;
  border: none;
}

.btn-edit {
  background: #2e20ab;
  color: #fff;
  border: none;
  padding: 6px 14px;
  border-radius: 4px;
  font-size: 12px;
}

/* ================= RESPONSIVE ================= */

/* Tablet */
@media (max-width: 1024px) {
  .form-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mobile */
@media (max-width: 600px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  .button-container button {
    flex: 1;
  }
}

`}
      </style>
    </Layout>
  );
};

export default HypothecationmasterDetailsDesign;
